module.exports = __webpack_public_path__ + "/login_ui/img/dm-726ddd1d1ef545533270b2f09ca9aabf.svg";